import dynamic from 'next/dynamic'
import { useContext } from 'react'

import { type SanityBlogPostWithoutBody } from '@data/sanity/queries/types/blog'
import { getLinkPageUrl } from '@lib/routes'
import { StringsContext } from '@lib/strings'

import ArrowRightIcon from '@components/icons/arrow-right'
import SimpleLink from '@components/simple-link'

const Photo = dynamic(() => import('@components/photo'))

interface BlogPostReadMoreProps {
  posts?: Array<SanityBlogPostWithoutBody>
}

const BlogPostReadMore = ({ posts }: BlogPostReadMoreProps) => {
  const strings = useContext(StringsContext)

  if (!posts || !posts.length) {
    return null
  }

  return (
    <section className="container my-10">
      <div className="border-t border-green-dark py-14">
        <div className="w-full max-w-3xl mx-auto">
          <h5 className="text-2xl mb-8">{strings.blogPostReadMore}</h5>
          <div className="flex flex-col gap-y-7">
            {posts.map((post) => (
              <div
                key={`read-${post.slug}`}
                className="w-full flex flex-col sm:flex-row gap-x-6"
              >
                {post.coverImage && (
                  <div className="relative w-full sm:w-[150px] sm:h-[90px] pb-[56.25%] sm:p-0 rounded-md overflow-hidden shrink-0 mb-3 sm:mb-0">
                    <Photo
                      fill
                      image={{
                        ...post.coverImage,
                        borderRadius: 'none',
                      }}
                      imageClassName="object-cover"
                    />
                  </div>
                )}
                <div>
                  <h5 className="text-2xl mb-3">{post.title}</h5>
                  <SimpleLink
                    href={getLinkPageUrl('blogPost', post.slug)}
                    className="group/read-more uppercase inline-flex items-center font-medium text-sm hover:underline"
                  >
                    <div className="group-hover/read-more:bg-yellow rounded-full mr-1 p-1">
                      <ArrowRightIcon id="read-more-icon" className="text-xl" />
                    </div>
                    {strings.blogPostReadMore}
                  </SimpleLink>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default BlogPostReadMore
